import React, { useState } from "react";
import MainLayout from "../../../layouts/main/main_layout";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { ArrowBackRounded, BadgeRounded, DeleteOutlineRounded, EditRounded } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/loading/loading";
import { useQuery } from "react-query";
import { SurveyorDetails } from "../model/surveyor_details";
import {
  getDetailsOfSurveyor,
  getDetailsOfSurveyorChoices,
  removeSurveyor,
} from "../../../services/surveyor/surveyor";
import ConfirmDialog from "../../../components/confirm_dialog/confirm_dialog";
import { black, greyEnabled, purple, purpleLight, red, redLight } from "../../../theme/colors";
import { useFeedback } from "../../../providers/feedback/feeedback";
import useUser from "../../../providers/user/user_provider";
export default function ViewSurveyor() {
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [deleting, setDeleting] = useState(false);
  let { id } = useParams();
  const { showSnackbar } = useFeedback();
  const { hasPermission } = useUser();

  const { data: surveyorDetails, isLoading } = useQuery<SurveyorDetails>(
    ["surveyor-Details", id],
    async () => {
      let response = await getDetailsOfSurveyor({ id: +id! });
      return response?.data?.data;
    }
  );

  const { data: surveyorChoiceDetails } = useQuery(
    ["surveyorChoiceDetails", id],
    async () => {
      let response = await getDetailsOfSurveyorChoices({
        id: +id!,
        page: 1,
        size: 8,
      });
      return response?.data?.data || [];
    }
  );

  function deleteSurveyor() {
    setDeleting(true);
    removeSurveyor({ id: +id! })
      .then((res) => {
        showSnackbar("Surveyor deleted successfully");
        navigate("/surveyors");
      })
      .catch((e) => showSnackbar("Something went wrong"))
      .finally(() => {
        setDeleting(false);
        setOpenDeletePopup(false);
      });
  }

  const navigate = useNavigate();
  function listItem({
    title,
    value,
  }: {
    title: string;
    value: any;
  }): JSX.Element {
    return (
      <Box style={{ overflow: "hidden" }}>
        <Typography variant="body2" sx={{ color: black, fontWeight: 600, letterSpacing: 0.2 }}>
          {title}
        </Typography>
        <Typography sx={{ color: black, fontWeight: 500, mt: 0.25 }} textOverflow="ellipsis" overflow="hidden">
          {value || "-"}
        </Typography>
      </Box>
    );
  }

  function loading() {
    return (
      <Box
        height={300}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Loading />
      </Box>
    );
  }
  return (
    <MainLayout>
      <Grid container spacing={3} mt={2}>
        <Grid item md={8} lg={8} sm={12} xs={12}>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  bgcolor: purpleLight,
                  flexShrink: 0,
                }}
              >
                <BadgeRounded sx={{ color: purple, fontSize: 22 }} />
              </Box>
              <Box>
                <Typography variant="h5" fontWeight={700} color={black}>
                  Surveyor Details
                </Typography>
                <Typography variant="body2" color={greyEnabled}>
                  {surveyorDetails?.name || "View surveyor details."}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Card
            elevation={0}
            sx={{ width: "100%", borderRadius: 3, border: "1px solid #ECECEC" }}
          >
            <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
              <Box m={2}>
                {isLoading ? (
                  loading()
                ) : (
                  <Box overflow="auto" flex={1}>
                    <Grid container spacing={3}>
                      <Grid item md={6}>
                        {listItem({
                          title: "Agents Name",
                          value: surveyorDetails?.name,
                        })}
                      </Grid>
                      <Grid item md={6}>
                        {listItem({
                          title: "Mobile Number",
                          value: surveyorDetails?.mobileNumber,
                        })}
                      </Grid>
                      <Grid item md={6}>
                        {listItem({
                          title: "Agent Location",
                          value: surveyorDetails?.location,
                        })}
                      </Grid>

                      <Grid item md={6}>
                        {listItem({
                          title: "State",
                          value: surveyorDetails?.state,
                        })}
                      </Grid>
                      <Grid item md={6}>
                        {listItem({
                          title: "City",
                          value: surveyorDetails?.city,
                        })}
                      </Grid>
                      <Grid item md={6}>
                        {listItem({
                          title: "District",
                          value: surveyorDetails?.district,
                        })}
                      </Grid>
                    </Grid>
                    <Box mt={4}>
                      <Typography variant="body1" fontWeight={"600"}>
                        Surveys mapped
                      </Typography>
                    </Box>
                    {surveyorChoiceDetails?.list?.map(
                      (choice: {
                        choiceId: number;
                        questions: number;
                        name: string;
                        languages: string;
                        validFrom: string;
                        validTo: string;
                        id: number;
                      }) => {
                        return (
                          <>
                            <ListItem
                              sx={{
                                margin: 0,
                                padding: 0,
                              }}
                            >
                              <ListItemText
                                primary={choice?.name}
                                secondary={
                                  <Box display="flex" flexDirection="row">
                                    <Typography variant="body2">{`Questions:${choice.questions}`}</Typography>
                                    {/* <Box ml={3}>
                                                      <Typography variant="body2">{`Language:`}</Typography>
                                                      {surveyorsListData.list.map(
                                                        (item: string) => {
                                                          <Typography variant="body2" ml={3}>
                                                            {item}
                                                          </Typography>;
                                                        }
                                                      )}
                                                    </Box> */}
                                    <Typography
                                      variant="body2"
                                      ml={3}
                                    >{`Valid from:${choice.validFrom}`}</Typography>
                                    <Typography
                                      variant="body2"
                                      ml={3}
                                    >{`Valid to:${choice.validTo}`}</Typography>
                                  </Box>
                                }
                                primaryTypographyProps={{
                                  color: black,
                                }}
                                secondaryTypographyProps={{
                                  color: "#91278F",
                                }}
                              />
                            </ListItem>
                          </>
                        );
                      }
                    )}
                    <Box
                      display="flex"
                      flexDirection="row"
                      flexWrap="wrap"
                      mt={4}
                      gap={1.5}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Button
                        onClick={() => navigate(-1)}
                        variant="outlined"
                        startIcon={<ArrowBackRounded sx={{ height: 18, width: 18 }} />}
                        sx={{
                          borderColor: purple,
                          color: purple,
                          borderRadius: 2,
                          textTransform: "none",
                          fontWeight: 600,
                          "&:hover": { borderColor: purple, bgcolor: purpleLight },
                        }}
                      >
                        Back To Surveyors
                      </Button>
                      <Box display="flex" gap={1.5}>
                        {hasPermission("surveyors", "delete") && (
                          <Tooltip title="Delete surveyor">
                            <IconButton
                              onClick={() => setOpenDeletePopup(true)}
                              sx={{ bgcolor: redLight, "&:hover": { bgcolor: "#FBD9D6" } }}
                            >
                              <DeleteOutlineRounded sx={{ color: red, fontSize: 20 }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {hasPermission("surveyors", "update") && (
                          <Button
                            variant="contained"
                            disableElevation
                            startIcon={<EditRounded sx={{ height: 18, width: 18 }} />}
                            sx={{
                              bgcolor: purple,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              "&:hover": { bgcolor: "#7A2074" },
                            }}
                            onClick={() => {
                              navigate("/surveyors/modifySurveyorDetails/", {
                                state: { id: +id! },
                              });
                            }}
                          >
                            Modify
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={openDeletePopup}
        onClose={() => setOpenDeletePopup(false)}
        onConfirm={deleteSurveyor}
        title="Delete Surveyor"
        message={`Are you sure you want to delete "${surveyorDetails?.name}"? This cannot be undone.`}
        confirmLabel="Delete"
        destructive
        loading={deleting}
      />
    </MainLayout>
  );
}
